import { createRouter, createWebHashHistory } from 'vue-router';
import { createApp } from 'vue';
import Help from '../component/view/Help.vue';


// 404エラーリダイレクト用のコンポーネント
const Redirect404Component = {
    mounted() {
        window.location.href = '/web/error/404';
    },
    template: ''
};

export const routes = [
    {
        path: '/',
        component: Redirect404Component,
    },
    {
        path: '/error',
        component: Redirect404Component,
    },
    {
        path: '/top/:helpPageKind',
        component: {
            mounted() {
                window.location.href = `/web/common/help/top/${this.$route.params.helpPageKind}`;
            },
            template: ''
        },
    },
    {
        path: '/answer/:helpId',
        component: {
            mounted() {
                window.location.href = `/web/common/help/answer/${this.$route.params.helpId}`;
            },
            template: ''
        },
    },
    {
        path: '/:pathMatch(.*)*',
        component: Redirect404Component,
    }
];

const router = createRouter({
    history: createWebHashHistory(),
    routes
});

const vue = createApp(Help)
    .use(router)
    .mount('#help');

export default vue;
